"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftSaleConfigLineItemToJSON = exports.NftSaleConfigLineItemFromJSONTyped = exports.NftSaleConfigLineItemFromJSON = void 0;
function NftSaleConfigLineItemFromJSON(json) {
    return NftSaleConfigLineItemFromJSONTyped(json, false);
}
exports.NftSaleConfigLineItemFromJSON = NftSaleConfigLineItemFromJSON;
function NftSaleConfigLineItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftTracker': json['nftTracker'],
        'quantity': json['quantity'],
    };
}
exports.NftSaleConfigLineItemFromJSONTyped = NftSaleConfigLineItemFromJSONTyped;
function NftSaleConfigLineItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftTracker': value.nftTracker,
        'quantity': value.quantity,
    };
}
exports.NftSaleConfigLineItemToJSON = NftSaleConfigLineItemToJSON;
